module.exports = __webpack_public_path__ + "static/media/logo.f391e657.svg";